import { ReceiveCartFooter } from './ReceiveCartFooter';
import { ReceiveCartItems } from './ReceiveCartItems';
import { ReceiveCartItemsHeader } from './ReceiveCartItemsHeader';
import type { CartGetItem } from 'src/types';

type Props = {
  cartItems: CartGetItem[];
  cartVendor: string;
  cartTotalPrice: string;
  cartCCY: string;
  cartCCYS: string;
  cartTimestamp: number;
  cartStore: string;
  cartLocale?: string;
};

export const ReceiveBody = ({
  cartItems,
  cartVendor,
  cartTotalPrice,
  cartCCY,
  cartCCYS,
  cartTimestamp,
  cartStore,
  cartLocale,
}: Props) => {
  return (
    <div style={{ minHeight: window.innerHeight - 300 }}>
      <ReceiveCartItemsHeader
        cartItems={cartItems}
        cartVendor={cartVendor}
        cartTimestamp={cartTimestamp}
        cartStore={cartStore}
      />
      <ReceiveCartItems
        cartItems={cartItems}
        cartVendor={cartVendor}
        cartTimestamp={cartTimestamp}
        cartCCY={cartCCY}
        cartCCYS={cartCCYS}
        cartLocale={cartLocale}
      />
      <ReceiveCartFooter cartTotalPrice={cartTotalPrice} />
    </div>
  );
};
